<template>
  <component :is="resolvedThankYouPage" />
</template>

<script>
import {mapState} from "vuex";
import ThankYouPageBLG from "./ThankYouPageBLG.vue";
import ThankYouPageFantasy from "./ThankYouPageFantasy.vue";

const THANK_YOU_PAGE_COMPONENTS = {
  LandingPageBLG: ThankYouPageBLG,
  LandingPageFantasy: ThankYouPageFantasy,
};

export default {
  computed: {
    ...mapState(['brandConfig']),
    resolvedThankYouPage() {
      const landingPage = this.brandConfig?.landingPage;
      return THANK_YOU_PAGE_COMPONENTS[landingPage] || ThankYouPageFantasy;
    },
  },
}
</script>
